import { render, staticRenderFns } from "./insurance-policy.vue?vue&type=template&id=416af31a"
import script from "./insurance-policy.vue?vue&type=script&lang=js"
export * from "./insurance-policy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports